import { Asset } from '../../../queries/ats/titles/types/asset';
import { useDetails } from '../details-context';
import { DetailsDataProviderProps } from './details-data-provider';

export interface DataProviderChildProps extends Pick<DetailsDataProviderProps, 'children'> {
  asset: Asset;
}

export function DataProviderChild({ asset, children }: DataProviderChildProps) {
  const { focusedAsset, source } = useDetails('DefaultDataProviderChild');
  return children({ asset, focusedAsset, source });
}
